import router from '@/router.js'
import * as pictures from '@/utils/pictures'

export default {
  state: [{
    name: 'registrationPicture',
    label: 'Photo d\'immatriculation *',
    type: 'photo',
    value: {},
    required: true
  }, {
    name: 'counterPicture',
    label: 'Photo compteur *',
    type: 'photo',
    value: {},
    required: true
  }, {
    name: 'kilometers',
    label: 'Kilométrage au compteur *',
    placeholder: 'Nombre de km',
    type: 'number',
    value: null,
    required: true
  }, {
    name: 'counterInMiles',
    label: 'Mon compteur est en miles',
    type: 'checkbox',
    required: false
  }, {
    name: 'comment',
    label: 'Commentaires',
    placeholder: 'Maximum 200 caractères',
    type: 'textarea',
    value: null,
    required: false
  }, {
    name: 'confirm',
    label: 'Je certifie l\'exactitude des photos et du kilométrage *',
    type: 'checkbox',
    value: false,
    required: true
  }],

  getters: {
    stepDatas(state) {
      return (routeName) => {
        const route = router.resolve({name: routeName}).route
        return state.filter(d => {
          return route.meta.datas && route.meta.datas.includes(d.name)
        })
      }
    },
    isStepValid(state, getters) {
      return (routeName) => {
        return getters.stepDatas(routeName).reduce((acc, cur) => {
          // Any data from previous state is missing: invalid
          if(acc === false) return false
          // Optional: valid
          if(!cur.required) return true
          // Required and falsey: invalid
          if(cur.value === null || cur.value === '') return false
          // Required and empty object: invalid
          if(typeof(cur.value) === 'object' && !Object.keys(cur.value).length) return false
          // Checkbox needs true value
          if(cur.type === 'checkbox' && !cur.value) return false
          // Check kilometers constraints > 0 && < 999999
          if (cur.name === 'kilometers' && (cur.value < 1 || cur.value > 999998)) return false
          // Check next value
          return true
        }, true)
      }
    },
    findDataByName(state) {
      return (name) => state.find(d => d.name === name)
    },
  },

  mutations: {
    resetDatas(state) {
      state.forEach(s => {
        switch(s.type) {
          case 'photo':
            s.value = {}
          break
          case 'checkbox':
            s.value = false
          break
          default: s.value = null
        }
      })
    },
    savePhoto(state, {photo, metas, name}) {
      const data = this.getters.findDataByName(name)
      data.value = {
        data: photo,
        state: 'standby',
        ...metas
      }
    },
    removePhoto(state, {name}) {
      const data = this.getters.findDataByName(name)
      data.value = {}
    },
    updateValue(state, {name, value}) {
      const data = this.getters.findDataByName(name)
      data.value = value
    },
  },

  actions: {
    resetDatas({commit}) {
      commit('resetDatas')
    },
    async savePhoto({commit}, {photo, name}) {
      try {
        // From stream: Blob, from input: File
        const file = typeof(photo) === 'string' ? pictures.dataURItoBlob(photo) : photo

        // Remember original file size
        const originalSize = parseInt(file.size / 1024)

        // Get exif meta datas
        let metas = await pictures.metas({file})

        // Resize & turn
        const resized = await pictures.resize({
          file,
          opts: {
            maxWidth: 1024,
            maxHeight: 768,
            contain: true,
            orientation: metas.orientation,
          }
        })

        // Compress & convert
        const converted = await pictures.convert({canvas: resized})

        // Get file size
        const compressedSize = parseInt(converted.size / 1024)

        // Convert to base64
        const compressedPhoto = await pictures.fileToDataURI(converted)

        // Append new metas
        metas.width = resized.width
        metas.height = resized.height
        metas.originalSize = originalSize
        metas.compressedSize = compressedSize

        // Sanitize date formats
        metas.datetime = metas.datetime.toISOString()

        // Save client-side
        commit('savePhoto', {photo: compressedPhoto, metas, name})
      } catch(e) {
        const msg = (typeof e === 'string') 
          ? e 
          : `Le format (PDF, HEIC...) du fichier que vous essayez de télécharger n'est pas autorisé, car non horodaté.\nVeuillez, s'il vous plaît, télécharger un fichier image avec un des formats suivants : jpg, jpeg, png, tiff, jfif, bmp, gif, svg, tif.`;

        alert(msg)
      }
    },
    removePhoto({commit}, {name}) {
      commit('removePhoto', {name})
    },
    updateValue({commit}, {name, value}) {
      commit('updateValue', {name, value})
    },
  }
}
